import { type Routes } from '@angular/router';

import { authGuard } from '@echospaces-web-monorepo/es-auth';
import { superAdminGuard } from '@echospaces-web-monorepo/es-portal-admin';

/**
 * Portal SPA — customer super-admin / staff workspace.
 *
 * Hits portal-api for islands, spaces, content, members, etc.
 * Originally scaffolded as `admin-spa`; renamed when the BFF split
 * separated Echospaces-staff (admin-api / admin-spa) from
 * customer-facing super-admin (portal-api / portal-spa).
 */
export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@echospaces-web-monorepo/es-portal-shell').then((m) => m.ShellComponent),
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-shell').then((m) => m.DashboardComponent),
      },
      {
        path: 'islands',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-islands').then((m) => m.IslandListComponent),
      },
      {
        path: 'islands/:islandId',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-islands').then((m) => m.IslandDetailComponent),
      },
      {
        path: 'islands/:islandId/spaces',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-ecms').then((m) => m.SpaceTreePageComponent),
      },
      {
        path: 'content',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-ecms').then((m) => m.ContentListPageComponent),
      },
      {
        path: 'content/:id',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-ecms').then((m) => m.ContentDetailPageComponent),
      },
      {
        path: 'placeholders-links',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-ecms').then((m) => m.PlaceholdersLinksPageComponent),
      },
      {
        path: 'users',
        canMatch: [superAdminGuard],
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-admin').then((m) => m.AdminMembersPageComponent),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('@echospaces-web-monorepo/es-portal-admin').then((m) => m.adminRoutes),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('@echospaces-web-monorepo/es-portal-ecms').then((m) => m.SettingsPageComponent),
      },
    ],
  },
];
